// ** Router imports
import { useRoutes, Navigate } from "react-router-dom";

// ** GetRoutes
import { DefaultRoute, getRoutes } from "./routes";

// ** Hooks Imports
import { useLayout } from "@hooks/useLayout";

import { isUserLoggedIn } from "../utility/Utils";
import { useDispatch } from "react-redux";
import { lazy } from "react"

// import UnderMaintenance from "../views/UnderMaintenance";
const UnderMaintenance = lazy(() => import('../views/UnderMaintenance'))
// import Login from "../views/Login";
const Login = lazy(() => import('../views/Login'))
// import ForgotPassword from "../views/ForgotPassword";
const ForgotPassword = lazy(() => import('../views/ForgotPassword'))
// import NotAuthorized from "../views/NotAuthorized";
const NotAuthorized = lazy(() => import('../views/NotAuthorized'))
// import Error from "../views/Error";
const Error = lazy(() => import('../views/Error'))
// import Register from "../views/Register";
const Register = lazy(() => import('../views/Register'))
// import BlankLayout from "@layouts/BlankLayout";
const BlankLayout = lazy(() => import('@layouts/BlankLayout'))
// import LoginUsingPhone from "../views/LoginUsingPhone";
const LoginUsingPhone = lazy(() => import('../views/LoginUsingPhone'))
// import ResetPassword from "../views/ResetPassword";
const ResetPassword = lazy(() => import('../views/ResetPassword'))
// import SuccessPasswordChange from "../views/SuccessPasswordChange";
const SuccessPasswordChange = lazy(() => import('../views/SuccessPasswordChange'))
// import MainLandingPage from "../views/LandingPage/MainLandingPage/MainLandingPage";
const MainLandingPage = lazy(() => import('../views/LandingPage/MainLandingPage/MainLandingPage'))
// import StartSellingPage from "../views/SellerProgram/StartSellingPage/StartSellingPage";
const StartSellingPage = lazy(() => import('../views/SellerProgram/StartSellingPage/StartSellingPage'))
// import SellerRegistration from "../views/SellerProgram/SellerRegistration/SellerRegistration";
const SellerRegistration = lazy(() => import('../views/SellerProgram/SellerRegistration/SellerRegistration'))
// import SellerTermsAndPolicies from "../views/SellerProgram/SellerTermsAndPolicies/SellerTermsAndPolicies";
const SellerTermsAndPolicies = lazy(() => import('../views/SellerProgram/SellerTermsAndPolicies/SellerTermsAndPolicies'))
// import SellerApproval from "../views/SellerProgram/SellerApproval/SellerApproval";
const SellerApproval = lazy(() => import('../views/SellerProgram/SellerApproval/SellerApproval'))
// import SellerContactUs from "../views/SellerProgram/SellerContactUs/SellerContactUs";
const SellerContactUs = lazy(() => import('../views/SellerProgram/SellerContactUs/SellerContactUs'))
// import SellerTrainingResources from "../views/SellerProgram/SellerTrainingResources/SellerTrainingResources";
const SellerTrainingResources = lazy(() => import('../views/SellerProgram/SellerTrainingResources/SellerTrainingResources'))
// import SellerCustomerSupport from "../views/SellerProgram/SellerCustomerSupport/SellerCustomerSupport";
const SellerCustomerSupport = lazy(() => import('../views/SellerProgram/SellerCustomerSupport/SellerCustomerSupport'))
// import CheckEmail from "../views/CheckEmail";
const CheckEmail = lazy(() => import('../views/CheckEmail'))
// import RoleSelection from "../views/RoleSelection";
const RoleSelection = lazy(() => import('../views/RoleSelection'))
// import OtherCategories from "../views/Frontend/OtherCategories/OtherCategories";
const OtherCategories = lazy(() => import('../views/Frontend/OtherCategories/OtherCategories'))
// import OfficialBrandStore from "../views/Frontend/OfficialBrandStore/OfficialBrandStore";
const OfficialBrandStore = lazy(() => import('../views/Frontend/OfficialBrandStore/OfficialBrandStore'))
// import Testimonials from "../views/LandingPage/Testimonials/Testimonials";
const Testimonials = lazy(() => import('../views/LandingPage/Testimonials/Testimonials'))
// import SocialMediaLinks from "../views/LandingPage/SocialMediaLinks/SocialMediaLinks";
const SocialMediaLinks = lazy(() => import('../views/LandingPage/SocialMediaLinks/SocialMediaLinks'))
// import SubscriptionPlans from "../views/LandingPage/SubscriptionPlans/SubscriptionPlans";
const SubscriptionPlans = lazy(() => import('../views/LandingPage/SubscriptionPlans/SubscriptionPlans'))
// import AboutUs from "../views/LandingPage/AboutUs/AboutUs";
const AboutUs = lazy(() => import('../views/LandingPage/AboutUs/AboutUs'))
// import SellerSubscriptionPlans from "../views/SellerProgram/SellerSubscriptionPlans/SellerSubscriptionPlans";
const SellerSubscriptionPlans = lazy(() => import('../views/SellerProgram/SellerSubscriptionPlans/SellerSubscriptionPlans'))
// import Team from "../views/LandingPage/Team/Team";
const Team = lazy(() => import('../views/LandingPage/Team/Team'))
// import CustomerServicesSection from "../views/UserPortal/CustomerServices/CustomerServicesSection";
const CustomerServicesSection = lazy(() => import("../views/UserPortal/CustomerServices/CustomerServicesSection"));
// import CustomerServices from "../views/UserPortal/CustomerServices/CustomerServices";
const CustomerServices = lazy(() => import("../views/UserPortal/CustomerServices/CustomerServices"));
// import ContactUs from "../views/UserPortal/CustomerServices/ContactUs/ContactUs";
const ContactUs = lazy(() => import("../views/UserPortal/CustomerServices/ContactUs/ContactUs"));
// import FAQs from "../views/UserPortal/CustomerServices/FAQs/FAQs";
const FAQs = lazy(() => import("../views/UserPortal/CustomerServices/FAQs/FAQs"));


const RouterComponent = () => {
  // ** Hooks
  const { layout } = useLayout();
  const dispatch = useDispatch();

  const allRoutes = getRoutes(layout);

  const getHomeRoute = () => {
    if (isUserLoggedIn()) {
      return DefaultRoute;
    }
  };

  const routes = useRoutes([
    {
      path: "/",
      element: <Navigate replace to={getHomeRoute()} />,
    },
    {
      path: "/under-maintenance",
      element: <BlankLayout />,
      children: [{ path: "/under-maintenance", element: <UnderMaintenance /> }],
    },
    {
      path: "/login",
      // element:<BlankLayout  />,
      children: [{ path: "/login", element: <Login /> }],
    },
    {
      path: "/login-phone",
      element: <BlankLayout />,
      children: [{ path: "/login-phone", element: <LoginUsingPhone /> }],
    },
    {
      path: "/reset-password",
      // element:<BlankLayout />,
      children: [{ path: "/reset-password", element: <ResetPassword /> }],
    },
    {
      path: "/reset-password-success",
      // element:<BlankLayout />,
      children: [
        { path: "/reset-password-success", element: <SuccessPasswordChange /> },
      ],
    },
    {
      path: "/register",
      // element:<BlankLayout />,
      children: [{ path: "/register", element: <Register /> }],
    },
    {
      path: "/forgot-password",
      // element: <BlankLayout />,
      children: [{ path: "/forgot-password", element: <ForgotPassword /> }],
    },
    {
      path: "/validate-email",
      // element: <BlankLayout />,
      children: [{ path: "/validate-email", element: <CheckEmail /> }],
    },
    {
      path: "/auth/not-auth",
      element: <BlankLayout />,
      children: [{ path: "/auth/not-auth", element: <NotAuthorized /> }],
    },
    {
      path: "/landingpage",
      element: <BlankLayout />,
      children: [{ path: "/landingpage", element: <MainLandingPage /> }],
    },
    {
      path: "/choose-role",
      // element: <BlankLayout />,
      children: [{ path: "/choose-role", element: <RoleSelection /> }],
    },
    // {
    //   path: '/product-listing',
    //   element: <BlankLayout />,
    //   children: [{ path: '/product-listing', element: <ProductListing /> }],
    // },
    // {
    //   path: '/product-details',
    //   element: <BlankLayout />,
    //   children: [{ path: '/product-details', element: <ProductListingDetails /> }],
    // },
    {
      path: "/startselling",
      element: <BlankLayout />,
      children: [{ path: "/startselling", element: <StartSellingPage /> }],
    },
    {
      path: "/sellerregistration",
      element: <BlankLayout />,
      children: [
        { path: "/sellerregistration", element: <SellerRegistration /> },
      ],
    },
    {
      path: "/sellerterms",
      element: <BlankLayout />,
      children: [{ path: "/sellerterms", element: <SellerTermsAndPolicies /> }],
    },
    {
      path: "/sellersubscription",
      element: <BlankLayout />,
      children: [
        { path: "/sellersubscription", element: <SellerSubscriptionPlans /> },
      ],
    },
    {
      path: "/sellerapproval",
      element: <BlankLayout />,
      children: [{ path: "/sellerapproval", element: <SellerApproval /> }],
    },
    {
      path: "/sellercontactus",
      element: <BlankLayout />,
      children: [{ path: "/sellercontactus", element: <SellerContactUs /> }],
    },
    {
      path: "/sellertraining",
      element: <BlankLayout />,
      children: [
        { path: "/sellertraining", element: <SellerTrainingResources /> },
      ],
    },
    {
      path: "/sellersupport",
      element: <BlankLayout />,
      children: [
        { path: "/sellersupport", element: <SellerCustomerSupport /> },
      ],
    },
    {
      path: "/other-categories",
      element: <BlankLayout />,
      children: [{ path: "/other-categories", element: <OtherCategories /> }],
    },
    {
      path: "/brand-store",
      element: <BlankLayout />,
      children: [{ path: "/brand-store", element: <OfficialBrandStore /> }],
    },
    {
      path: "/testimonials",
      element: <BlankLayout />,
      children: [{ path: "/testimonials", element: <Testimonials /> }],
    },
    {
      path: "/social-media-links",
      element: <BlankLayout />,
      children: [
        { path: "/social-media-links", element: <SocialMediaLinks /> },
      ],
    },
    {
      path: "/subscription-plans",
      element: <BlankLayout />,
      children: [
        { path: "/subscription-plans", element: <SubscriptionPlans /> },
      ],
    },
    {
      path: "/about-us",
      element: <BlankLayout />,
      children: [{ path: "/about-us", element: <AboutUs /> }],
    },
    {
      path: "/team",
      element: <BlankLayout />,
      children: [{ path: "/team", element: <Team /> }],
    },
    {
      path: "/customer-services-section",
      element: <BlankLayout />,
      children: [
        {
          path: "/customer-services-section",
          element: <CustomerServicesSection />,
        },
      ],
    },
    {
      path: "/customer-services",
      element: <BlankLayout />,
      children: [{ path: "/customer-services", element: <CustomerServices /> }],
    },
    {
      path: "/contact-us",
      element: <BlankLayout />,
      children: [{ path: "/contact-us", element: <ContactUs /> }],
    },
    {
      path: "/FAQs",
      element: <BlankLayout />,
      children: [{ path: "/FAQs", element: <FAQs /> }],
    },
    {
      path: "*",
      element: <BlankLayout />,
      children: [{ path: "*", element: <Error /> }],
    },
    ...allRoutes,
  ]);

  return routes;
};

export default RouterComponent;